import { ItemIcon, PixelPlaceholderLoader, Type } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { percentageFilter } from "app/filters/ngFilters";
import { addPercent } from "app/pages/activation/helpers/format";

import { LOADER_HEIGHT, LOADER_WIDTH } from "../../constants";
import { leaderKeys } from "../automationKeys";

import {
    StyledLeaderWrapper,
    StyledLeaderTitle,
    StyledLeaderValue,
    StyledLeaderWebsiteWrapper,
    StyledDomain,
    StyledDisabledLeaderDomain,
    StyledDisabledLeaderIcon,
} from "./styles";
import { LEADER_LABEL } from "./texts";
import type { LeaderSchema } from "./type";

export const Leader = ({ share, domain, iconSrc, isLoading, isSuggested }: LeaderSchema) => {
    const leaderInfo = isSuggested ? (
        <>
            <StyledDisabledLeaderIcon />
            <StyledDisabledLeaderDomain />
        </>
    ) : (
        <>
            <ItemIcon
                iconType={Type.Website}
                iconSrc={iconSrc}
            />
            <StyledDomain data-automation={leaderKeys.domain}>{domain}</StyledDomain>
        </>
    );

    return (
        <StyledLeaderWrapper data-automation={leaderKeys.wrapper(domain)}>
            <StyledLeaderTitle data-automation={leaderKeys.title}>{translate(LEADER_LABEL)}</StyledLeaderTitle>

            {isLoading ? (
                <span data-automation={leaderKeys.preloader}>
                    <PixelPlaceholderLoader
                        height={LOADER_HEIGHT}
                        width={LOADER_WIDTH}
                    />
                </span>
            ) : (
                <StyledLeaderWebsiteWrapper>
                    <StyledLeaderValue data-automation={leaderKeys.value}>
                        {addPercent(percentageFilter()(share, 1))}
                    </StyledLeaderValue>
                    {leaderInfo}
                </StyledLeaderWebsiteWrapper>
            )}
        </StyledLeaderWrapper>
    );
};
